export default {
  redirectTo(url: string) {
    window.location.assign(url);
  },
};
